module.exports = __webpack_public_path__ + "img/img01_text_m.940173a8.png";